import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background-50">
      <div className="text-center px-4">
        <div className="text-8xl font-extrabold text-primary-500 font-heading mb-4">404</div>
        <h1 className="text-xl font-semibold text-foreground-900 mb-2">页面未找到</h1>
        <p className="text-sm text-foreground-600 mb-8 max-w-md mx-auto">
          抱歉，您访问的页面不存在或已被移除。请检查URL是否正确，或返回51黑料首页浏览更多精彩内容。
        </p>
        <Link
          to="/"
          className="inline-block px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer"
        >
          <i className="ri-home-line mr-1.5"></i>
          返回首页
        </Link>
      </div>
    </div>
  );
}